import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { ContentWithCardLoading } from "../../../../components/loading";
import AdvanceDataTable from "../../../../components/normal-table/advance-table";
import { CustomSubHeader } from "../../../../components/subheader";
import { SubheaderNav } from "../../../../components/subheader/subheaderNav";
import ContentWrapper from "../../../Wrapper";
import SenderIdSidePanel from "../../components/senderId-side-panel";
import * as senderIdActions from "../../store/actions/sender_id_list_actions";

const SENDER_ID_ACTIONS = {
  NONE: "NONE",
  EDIT: "EDIT",
  DELETE: "DELETE",
};

export default function SenderIdList() {
  const [selectedSenderIdWithAction, setSelectedSenderIdWithAction] = useState({ action: SENDER_ID_ACTIONS.NONE, data: {} });

  const [limit, setLimit] = useState(10);
  const [pageNo, setPageNo] = useState(1);
  const links = [{ name: "Pending", }, { name: "Rejected" }, { name: "Approved" }];
  const [selectedTab, setSelectedTab] = useState("Pending")
  const senderIdList = useSelector((state) => state.senderIds.senderIdList);
  const dispatch = useDispatch();

  useEffect(() => {
    dispatch(senderIdActions.getListOfSenderIdRequest({ limit: limit, page: pageNo, type: selectedTab.toLowerCase() }));
  }, [dispatch, limit, pageNo, selectedTab]);

  return (
    <ContentWrapper subHeader={<CustomSubHeader>
      <div>
        <SubheaderNav links={links} active={selectedTab} onClick={setSelectedTab} />
      </div>
    </CustomSubHeader>}>
      {senderIdList.loading ? (
        <ContentWithCardLoading />
      ) : senderIdList.data.length === 0 ? (
        "No accounts"
      ) : (
        <>
          <div className={`card card-custom`}>
            <div className="card-body py-3 px-3" style={{ padding: 15 }}>
              <AdvanceDataTable
                columns={[
                  { title: "Company Name", apiKeyName: "companyName", fieldInputType: "INPUT" },
                  { title: "User Email", apiKeyName: "userEmail", fieldInputType: "INPUT" },
                  { title: "Sender Id", apiKeyName: "senderId", fieldInputType: "INPUT" },
                  { title: "Country", apiKeyName: "country", fieldInputType: "COUNTRY_ISO_DISPLAY" },
                  { title: "Route", apiKeyName: "route", fieldInputType: "INPUT" },
                  { title: "Status", apiKeyName: "status", fieldInputType: "INPUT" },
                  { title: "Actions", isAction: true, options: ["edit"] },
                ]}
                data={senderIdList.data}
                limit={limit}
                pageNo={pageNo}
                setLimit={setLimit}
                setPageNo={setPageNo}
                count={senderIdList.count}
                // actions
                handleEdit={(data) => setSelectedSenderIdWithAction({ action: SENDER_ID_ACTIONS.EDIT, data })}
              />
            </div>
          </div>
          <SenderIdSidePanel
            show={selectedSenderIdWithAction.action === SENDER_ID_ACTIONS.EDIT}
            senderIdData={selectedSenderIdWithAction.data}
            loadingData={{ limit, pageNo }}
            handleClose={() => setSelectedSenderIdWithAction({ action: SENDER_ID_ACTIONS.NONE, data: {} })}
          />
        </>
      )}
    </ContentWrapper>
  );
}
